import { Navigate, NavLink, Outlet, Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

const TABS = [
  { to: '/admin', label: 'Overview', end: true },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/professional-requests', label: 'Professional requests' },
  { to: '/admin/flagged-reports', label: 'Flagged reports' },
  { to: '/admin/contacts', label: 'Contacts' },
  { to: '/admin/checkpoints', label: 'Checkpoints' },
]

export default function AdminLayout() {
  const { isAuthenticated, isAdmin, username } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    const from = location.pathname + location.search
    return <Navigate to="/login" state={{ from }} replace />
  }
  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-sm text-center">
          <p className="text-sm font-semibold text-gray-900">Admin access required</p>
          <p className="mt-1 text-sm text-gray-500">
            Your account doesn't have admin privileges on this platform.
          </p>
          <Link to="/" className="mt-4 inline-block text-sm text-blue-600 hover:text-blue-700 font-medium">
            ← Back to map
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/" className="text-sm text-blue-600 hover:text-blue-700 font-medium">
              ← Map
            </Link>
            <span className="text-sm font-semibold text-gray-900">Admin control plane</span>
          </div>
          <span className="text-xs text-gray-500">{username}</span>
        </div>
        <nav className="max-w-6xl mx-auto px-4 flex gap-1 overflow-x-auto">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 py-2 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300'
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
